export default __webpack_public_path__ + "static/media/hive.25798c33.png";